<template>
  <div class="member-wrapper">
    <member-header :value="user" :moneys="moneys" @pay="onShowPay" @extract="onExtract" />
    <member-list :is_distribution="!!user.is_distribution" @show="onShow" />

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <van-image @click.stop :src="src" width="50%" />
      </div>
    </van-overlay>

    <van-dialog
      v-model="payTypeShow"
      title="充值方式"
      show-cancel-button
      @confirm="onSelectPayType"
      @cancel="onCancel"
    >
      <van-radio-group v-model="radio">
        <van-radio name="1">兑换码充值</van-radio>
        <van-radio name="2">直接充值</van-radio>
      </van-radio-group>
    </van-dialog>

    <van-dialog
      v-model="payShow"
      :title="title"
      show-cancel-button
      @confirm="onSelectPay"
      @cancel="onCancel"
    >
      <van-cell-group>
        <van-field
          v-if="radio === '1'"
          v-model="code"
          label="兑换码"
          clearable
          placeholder="请输入兑换码"
        />
        <van-field
          v-else
          v-model="price"
          type="number"
          label="金额"
          clearable
          placeholder="请输入充值金额"
        />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  getMemberExtractMoney,
  postMemberExtractMoney,
  getMemberPayCode,
  getMemberPay,
  getMemberExchangeCode,
} from '@/api/api-user';
import { choosePayment } from '@/utils/util';
import MemberHeader from './MemberHeader';
import MemberList from './MemberList';

export default {
  components: {
    MemberHeader,
    MemberList,
  },
  data() {
    return {
      moneys: {},
      payCodeDate: {},
      show: false,
      radio: '1',
      payTypeShow: false,
      payShow: false,
      code: '',
      price: '',
      src: '',
    };
  },
  computed: {
    ...mapGetters(['user']),
    title() {
      if (this.radio === '2') {
        return '直接充值';
      }
      return '兑换码充值';
    },
  },
  created() {
    this.getUser();
    this.getPayCode();
    this.onGetPrice();
  },
  methods: {
    ...mapActions(['getUser']),
    async onGetPrice() {
      try {
        const data = await getMemberExtractMoney();
        this.moneys = data;
      } catch (error) {}
    },
    onSelectPayType() {
      this.payShow = true;
      this.payTypeShow = false;
    },
    onCancel() {
      this.radio = '1';
      this.code = '';
      this.price = '';
    },
    onShowPay() {
      this.payTypeShow = true;
    },
    onSelectPay() {
      if (this.radio === '1') {
        this.onExchange();
      } else {
        this.onPay();
      }
      this.radio = '1';
    },
    async onExchange() {
      try {
        const data = await getMemberExchangeCode({ code: this.code });
        if (Array.isArray(data)) {
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        }
        this.code = '';
      } catch (error) {}
    },
    async onPay() {
      try {
        const data = await getMemberPay({ price: this.price });
        if (data) {
          await choosePayment(data);
          setTimeout(() => {
            this.$router.go(0); // 支付成功
          }, 500);
        }
      } catch (error) {
      } finally {
        this.price = '';
      }
    },
    async onExtract() {
      try {
        const flag = await postMemberExtractMoney({ time: this.moneys.time || '' });
        if (flag) {
          this.$router.push({ name: 'member_extract' });
        }
      } catch (error) {}
    },
    async getPayCode() {
      try {
        const data = await getMemberPayCode();
        this.payCodeDate = data;
      } catch (error) {}
    },
    onShow({ type }) {
      if (type === 1) {
        this.src = this.payCodeDate.qr_img;
        this.show = true;
      } else if (type === 2) {
        this.src = this.user.distribution_qr_img;
        this.show = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.member-wrapper {
  margin-bottom: 50px;
  .van-dialog__content {
    .van-radio-group {
      padding: 10px 32px;
      .van-radio {
        padding: 10px 0;
      }
    }
    .van-cell-group {
      margin: 20px 0;
      &::after {
        border: 0;
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .pay_overlay {
    background-color: white;
    .pay_wrapper {
      padding: 0 2vw;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-flow: row wrap;
      .pay_wrapper_item {
        margin: 1vw;
        padding: 3vw 5.9vw;
        border: 1px solid #07c160;
        border-radius: 1vw;
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        color: #07c160;
        span {
          margin: 1vw 0;
        }
        .price {
          font-size: 18px;
          font-weight: bold;
        }
        .cost {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
